@if (form) {
    <form nz-form [formGroup]="form" (ngSubmit)="submitForm(form)" class="adspt-form ant-row">
        <nz-form-item adsptFormInputStates class="ant-col ant-col-xs-12 ant-col-md-12 input-items">
            <nz-form-label>{{ 'portal.your-email' | translate }}</nz-form-label>

            <nz-form-control [nzErrorTip]="'settings.billing.mail-error' | translate">
                <input
                    nz-input
                    formControlName="email"
                    placeholder="hello@adspert.de"
                    (cdkAutofill)="onAutoFill($event)"
                />
            </nz-form-control>
        </nz-form-item>

        <nz-form-item adsptFormInputStates class="ant-col ant-col-xs-12 ant-col-md-12 input-items">
            <nz-form-label>{{ 'common.re-login.password' | translate }}</nz-form-label>

            <nz-form-control [nzErrorTip]="'common.re-login.password-error' | translate">
                <input
                    nz-input
                    formControlName="password"
                    placeholder="********"
                    type="password"
                    (cdkAutofill)="onAutoFill($event)"
                />
            </nz-form-control>
        </nz-form-item>

        <div class="ant-col ant-col-xs-12 ant-col-md-12 art-mb-8 art-mt-8">
            <ng-content></ng-content>
            <a [href]="forgotPasswordUrl()">{{ 'common.re-login.forgot-password' | translate }}</a>
        </div>

        <nz-form-item class="ant-col ant-col-xs-12 ant-col-md-12">
            <nz-form-control>
                <div class="a-fx-col a-fx-gap-16 art-mt-16">
                    <button
                        nz-button
                        nzSize="large"
                        nzType="primary"
                        type="submit"
                        [disabled]="form.pristine || form.invalid"
                        [nzLoading]="processing()"
                    >
                        {{ 'portal.login' | translate }}
                    </button>
                    <nz-divider />
                    <adspt-mirakl-login-button />
                </div>
            </nz-form-control>
        </nz-form-item>
    </form>
}
